let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("cOBj9"), load("jgfeV"), load("gYKCE"), load("f4DD6")]).then(() => parcelRequire('6JHmj'));